import Modal from "react-modal";
import ModalStyle from "Assets/ModalStyle";

import type PlantModel from "Models/Plant";
import { usePlantingStore } from "Store/PlantingStore";
import { useGerminationTrayStore } from "Store/GerminationTrayStore";

type Props = {
  plantingId?: string;
  hideDeleteModal: () => void;
  showDeleteModal: boolean;
  clearPlanting?: () => void;
  updatePlant?: (plant: PlantModel | undefined) => void;
  index: number;
};

const DeletePlantingModal: React.FC<Props> = ({
  plantingId,
  hideDeleteModal,
  showDeleteModal,
  clearPlanting,
  index,
}) => {
  const deletePlanting = usePlantingStore((state) => state.deletePlanting);
  const updatePlantingAtIndex = useGerminationTrayStore(
    (state) => state.updatePlantingAtIndex,
  );
  const refreshPlantings = usePlantingStore((state) => state.getPlantings);
  const planting = usePlantingStore((state) =>
    state.plantings.find((item) => item._id === plantingId),
  );

  const handleDelete = async () => {
    if (!planting) {
      return;
    }

    await deletePlanting(planting._id);
    clearPlanting?.();
    await updatePlantingAtIndex(index);
    const currentTray =
      useGerminationTrayStore.getState().currentGerminationTray;
    if (currentTray) {
      const plantingIds = currentTray.plantingIds.filter(
        (id): id is string => id !== null,
      );
      await refreshPlantings(plantingIds);
    }
    hideDeleteModal();
  };

  return (
    <Modal
      style={ModalStyle.defaultStyle}
      ariaHideApp={false}
      isOpen={!!planting && showDeleteModal}
    >
      <div className="m-50 p-5">
        <h3 className="text-lg py-5">Delete Planting</h3>
        <p>Are you sure you want to delete this planting?</p>
        <div className="flex pt-10">
          <button
            onClick={() => hideDeleteModal()}
            className="btn bg-gray-light mr-5"
          >
            Cancel
          </button>
          <button
            onClick={() => void handleDelete()}
            className="btn btn-danger"
          >
            Delete
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeletePlantingModal;
